var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnknownPaymentInstrumentIcon = function SvgUnknownPaymentInstrumentIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 21,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 21,
    rx: 3.5,
    stroke: "#AEAEAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6395 10.7395C16.1664 9.78842 17.179 9.22737 17.7674 8.38579C18.39 7.50316 18.0411 5.85421 16.2758 5.85421C15.1195 5.85421 14.5516 6.73 14.3121 7.45526L12.54 6.70947C13.0258 5.25211 14.3464 4 16.269 4C17.8769 4 18.9785 4.73211 19.5395 5.64895C20.0185 6.43579 20.299 7.90684 19.56 9.00158C18.739 10.2126 17.9521 10.5821 17.5279 11.3621C17.3569 11.6768 17.2885 11.8821 17.2885 12.8947H15.3111C15.3043 12.3611 15.2221 11.4921 15.6395 10.7395ZM17.6443 15.6316C17.6443 16.3842 17.0285 17 16.2758 17C15.5232 17 14.9074 16.3842 14.9074 15.6316C14.9074 14.8789 15.5232 14.2632 16.2758 14.2632C17.0285 14.2632 17.6443 14.8789 17.6443 15.6316Z",
    fill: "#AEAEAE"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnknownPaymentInstrumentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "unknown-payment-instrument-icon.b82c8d9bc9f1ca6f1e41cae88c810211.svg";